import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CheckoututilService {
  /**
]   * @param checkoutUrl 
   * @returns 
   */
  extractCheckoutIdFromUrl(checkoutUrl: string): string | null {
    try {
      const url = new URL(checkoutUrl);
      const pathSegments = url.pathname.split('/').filter((segment) => segment.length > 0);

      const checkoutId = pathSegments[pathSegments.length - 1];

      if (checkoutId && checkoutId.length > 0) {
        console.log('Extracted checkout ID from URL:', checkoutId);
        return checkoutId;
      }

      console.error('Could not extract checkout ID from URL:', checkoutUrl);
      return null;
    } catch (error) {
      console.error('Error extracting checkout ID:', error);
      return null;
    }
  }

  /**
   * @returns The extracted checkout ID from URL parameters or null if not found.
   */
  getCheckoutIdFromUrlParams(): string | null {
    try {
      const urlParams = new URLSearchParams(window.location.search);

      const checkoutId =
        urlParams.get('checkoutid') ||
        urlParams.get('checkoutId') ||
        urlParams.get('checkout_id') ||
        urlParams.get('id');

      if (checkoutId) {
        console.log('Found checkout ID in URL parameters:', checkoutId);
        return checkoutId;
      }

      return null;
    } catch (error) {
      console.error('Error getting checkout ID from URL parameters:', error);
      return null;
    }
  }

  /**
   * @returns The stored checkout ID or null if not found.
   */
  getCheckoutId(): string | null {
    return localStorage.getItem('checkoutId');
  }

  clearStoredCheckoutId(): void {
    localStorage.removeItem('checkoutId');
    console.log('Cleared stored checkout ID from localStorage.');
  }

  /**
   * @param checkoutId The checkout ID string to store.
   */
  storeCheckoutId(checkoutId: string): void {
    try {
      // IMPORTANT: Use 'checkoutId' as the key to be consistent with getCheckoutId and clearStoredCheckoutId
      localStorage.setItem('checkoutId', checkoutId);
      console.log('Stored checkout ID in localStorage:', checkoutId);
    } catch (error) {
      console.error('Error storing checkout ID:', error);
    }
  }

  /**
   * @param baseUrl The base URL for the success page.
   * @param checkoutId The checkout ID to append.
   * @returns The complete success URL.
   */
  buildSuccessUrl(baseUrl: string, checkoutId: string): string {
    try {
      const url = new URL(baseUrl);
      url.searchParams.set('checkoutid', checkoutId);
      return url.toString();
    } catch (error) {
      console.error('Error building success URL:', error);
      return `${baseUrl}?checkoutid=${checkoutId}`;
    }
  }

  /**
   * @param checkoutId The string to validate.
   * @returns True if the string matches a UUID pattern, false otherwise.
   */
  isValidCheckoutId(checkoutId: string): boolean {
    if (!checkoutId) return false;

    // Regex for UUID v1-v5 with hyphens
    const uuidWithHyphensPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    // Regex for UUID without hyphens (32 hex characters)
    const uuidWithoutHyphensPattern = /^[0-9a-f]{32}$/i;

    return uuidWithHyphensPattern.test(checkoutId) || uuidWithoutHyphensPattern.test(checkoutId);
  }
}
